<template>
  <section class="storefinder__mapSection" >
    <div class="storefinder__map" v-show="optIn" ref="map"/>
    <div class="storefinder__map map__opt-in" v-if="!optIn" >
        <slot name="optIn" :isOptedIn="optIn" :allowMap="allowOptIn">
<!--          EXAMPLE CODE!!-->
<!--          Usage should be outside of the component-->
<!--          <div class="opt-in__container"  >-->
<!--              <p class="text&#45;&#45;center">Custom Text</p>-->
<!--              <button class="storefinder__button" @click="allowOptIn">Custom Text</button>-->
<!--          </div>-->
        </slot>
    </div>
    <slot :isOptedIn="optIn" :allowMap="allowOptIn" ></slot>
  </section>
</template>
<script>
  import { mapGetters, mapMutations } from 'vuex';
  import GoogleMapsApiLoader from 'google-maps-api-loader';
  import MarkerClusterer from '@googlemaps/markerclustererplus';

  export default {
    name: 'storefinder-map',
    props: {
      apiKey: {
        required: true,
        type: String
      },
      config: {
        type: Object
      },
      zoom: {
        type: Number,
        default: 1,
      },
      position: {
        type: Object,
        required: true,
      },
      clusterSize: {
        type: Number,
        default: 10,
      }
    },
    data() {
      return {
          map: null,
          google: null,
          optIn: sessionStorage.getItem("googleOptIn") === "true",
          markers: [],
          cluster: null,
      };
    },
    mounted(){
      this.initMap();
    },
    methods: {
      allowOptIn(){
        this.optIn = true;
        sessionStorage.setItem("googleOptIn", this.optIn);
      },
      addMarker(marker){
        this.cluster.addMarker(marker)
      },
      removeMarker(marker){
        this.cluster.removeMarker(marker)
      },
      initMap(){
        if(!this.optIn){return;}
        GoogleMapsApiLoader({ apiKey: this.apiKey }).then(google => {
          this.google = google;
          this.map = new google.maps.Map(this.$refs.map, {
            ...this.config,
            zoom: this.zoom,
            center: this.position,
          });

          this.cluster = new MarkerClusterer(this.map, [], {
            minimumClusterSize: this.clusterSize,
            styles: [{
              height: 36,
              width: 36,
              textSize: 18,
              className: 'storefinder_cluster',
              textColor: 'white',
            }],
          });
        });
      },
      getMap(found) {
        const checkForMap = () => {
          if (this.map && this.google) {
            found({map: this.map, google: this.google})
          } else {
            setTimeout(checkForMap, 50)
          }
        }
        checkForMap()
      },
    },
    provide(){
      return {
        getMap: this.getMap,
        addMarker: this.addMarker,
        removeMarker: this.removeMarker
      }
    },
    watch: {
      markers(markers){

      },
      optIn(){
        this.initMap()
      },
      position: {
        deep: true,
        handler(val){
          if(!this.map){return; }
          this.cluster.repaint();
          this.map.panTo(val);
        }
      },
      zoom(val){
        this.map.setZoom(val);
      }
    }
  };
</script>